import React from 'react';
import styled from 'styled-components';
import MotifToast from '@ey/motif-react-wrapper/Toast';

export default function Toast(props) {
	const {id, position, className, onClose, variant, children} = props;
	return (
		<StyledMotifToast id={id} position={position} variant={variant} className={className} onClose={onClose}>
			{children}
		</StyledMotifToast>
	);
}

const StyledMotifToast = styled(MotifToast)``;
